// extracted by mini-css-extract-plugin
export default {"bottom":"TaskList_bottom__nb1+C","select":"TaskList_select__WrGLf","ul":"TaskList_ul__XSxAW","li":"TaskList_li__hy8GN","grip":"TaskList_grip__Z9+h3","h3":"TaskList_h3__NA046"};